import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { tratarIsNullOrEmpty } from 'src/app/core/utils/utilities';
import { ICreateTransportadora } from 'src/app/services/TransportadoraService/transportadora.model';
import { TransportadoraService } from 'src/app/services/TransportadoraService/transportadora.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-cadastro-transportadora',
  templateUrl: './cadastro-transportadora.component.html',
  styleUrls: ['./cadastro-transportadora.component.scss']
})
export class CadastroTransportadoraComponent implements OnInit {
  form: FormGroup = this._inicializarFormulario();
  title: string = 'Cadastrar Transportadora';
  isLoading: boolean = false;
  statusInput: boolean = false;
  pkTransportadora: number = 0;
  modoEditar: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private transportadoraService: TransportadoraService,
    public swalAlert: SwalAlertService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      NM_TPTD: ['', [Validators.required, Validators.maxLength(100)]],
      TX_CNPJ_TPTD: [null, [Validators.required]],
      TX_CNTT_TPTD: [null, [Validators.required]]
    });
    return form;
  }

  ngOnInit(): void {
    this.stateForms();
  }

  createPayload(): ICreateTransportadora {
    return {
      NM_TPTD: tratarIsNullOrEmpty(this.form.controls['NM_TPTD'].value),
      TX_CNPJ_TPTD: tratarIsNullOrEmpty(this.form.controls['TX_CNPJ_TPTD'].value),
      TX_CNTT_TPTD: tratarIsNullOrEmpty(this.form.controls['TX_CNTT_TPTD'].value),
      NU_TPTD_STTS: 1
    };
  }

  postarDados() {
    this.isLoading = true;

    if (this.form.invalid) {
      this.isLoading = false;
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning'
      );
      return;
    }

    if (this.modoEditar) {
      const payload = {
        ...this.createPayload(),
        PK_TPTD: this.pkTransportadora
      };

      this.transportadoraService.UpdateTransportadora(payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/transportadora']);
        },
        error: (err) => {
          this.isLoading = false;
          this.swalAlert.handleError(
            err,
            'Erro!',
            'Ocorreu uma falha ao editar a transportadora.'
          );
        }
      });
      return;
    }

    this.transportadoraService.CreateTransportadora(this.createPayload()).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigate(['listagem/transportadora']);
      },
      error: (err) => {
        this.isLoading = false;
        this.swalAlert.handleError(
          err,
          'Erro!',
          'Ocorreu uma falha ao cadastrar a transportadora.'
        );
      }
    });
  }

  stateForms() {
    this.route.queryParams.subscribe(params => {
      if (params && params['codigo']) {
        this.modoEditar = true;
        this.title = 'Editar Transportadora';
        this.isLoading = true;

        this.transportadoraService
          .GetTransportadoraById(Number(params['codigo']))
          .subscribe({
            next: (response: any) => {
              const transportadora = response.transportadora ?? response.Transportadora ?? response;
              this.pkTransportadora = transportadora.PK_TPTD;
              this.form.controls['NM_TPTD'].setValue(transportadora.NM_TPTD ?? '');
              this.form.controls['TX_CNPJ_TPTD'].setValue(transportadora.TX_CNPJ_TPTD ?? '');
              this.form.controls['TX_CNTT_TPTD'].setValue(transportadora.TX_CNTT_TPTD ?? '');
              this.isLoading = false;
            },
            error: (err) => {
              this.isLoading = false;
              this.swalAlert.handleError(
                err,
                'Erro!',
                'Ocorreu uma falha ao carregar os dados da transportadora.'
              );
            }
          });
      }
    });
  }
}
